import cn from 'classnames';
import { CupertinoPane } from 'cupertino-pane';
import { ReactNode, useEffect, useRef } from 'react';
import styles from './BottomDrawer.module.scss';

type BottomDrawerProps = {
  children: ReactNode;
  active: boolean;
  closeFn: () => void;
  className?: string;
  drawerId: string;
  closeButton?: boolean;
};

export const BottomDrawer = ({
  children,
  closeFn,
  active,
  className,
  drawerId,
  closeButton,
}: BottomDrawerProps) => {
  const wrapperClassName = cn(styles.wrapper, className);
  const contentClassName = cn(styles.content, {
    [styles.closed]: !active,
  });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const PaneRef = useRef<any>(null);

  const handleClose = () => {
    PaneRef.current?.hide();
    closeFn();
  };

  const settings = {
    bottomClose: true,
    buttonDestroy: false,
    draggableOver: false,
    showDraggable: false,
    simulateTouch: false,
    events: {
      onBackdropTap: handleClose,
      onWillDismiss: handleClose,
    },
  };

  useEffect(() => {
    const root = document.querySelector('body');

    if (active && root) {
      root.classList.add('modal-opened');
    }
    if (!active && root) {
      root.classList.remove('modal-opened');
    }
  }, [active]);

  useEffect(() => {
    if (!PaneRef.current && active) {
      PaneRef.current = new (CupertinoPane as any)(`#${drawerId}`, {
        ...settings,
        parentElement: '#__next',
        bottomClose: true,
        cssClass: wrapperClassName,
        fitHeight: true,
        backdrop: true,
        simulateTouch: false,
        fastSwipeClose: true,
      });

      PaneRef.current.present({ animate: true });
    }

    return () => {
      if (PaneRef.current) {
        PaneRef.current.destroy({ animate: true });
        PaneRef.current = null;
      }
    };
  }, [active]);

  return (
    <>
      <div id={drawerId} className={contentClassName}>
        {closeButton && (
          <div className={styles.heading}>
            <img
              src="/svg/close-square-gray.svg"
              alt="close"
              onClick={handleClose}
              className={styles.close}
            />
          </div>
        )}
        {children}
      </div>
    </>
  );
};
